"use strict";

exports.__esModule = true;
exports.toPairs = toPairs;
exports.shallowCopyObj = shallowCopyObj;
/**
 * Convert obj to array of key value pairs
 *
 * @param {Object} obj A plain JS object
 *
 * @return {Array<Pair<string, Object>>} Pairs
 */
function toPairs(obj) {
  return Object.keys(obj).map(function (key) {
    return [key, obj[key]];
  });
}

/**
 * Create a shallow copy of provided object, will only use Object.keys
 * returned key.
 *
 * @param {Object|null} obj Object to copy
 *
 * @return {Object|null} A shallow copy of provided object, is input null,
 *                       return null.
 */
function shallowCopyObj(obj) {
  if (obj === null) {
    return null;
  }

  var copy = {};
  for (var _iterator = Object.keys(obj), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
    var _ref;

    if (_isArray) {
      if (_i >= _iterator.length) break;
      _ref = _iterator[_i++];
    } else {
      _i = _iterator.next();
      if (_i.done) break;
      _ref = _i.value;
    }

    var key = _ref;

    copy[key] = obj[key];
  }
  return copy;
}


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-container-query/lib/DataStructure.js
 ** module id = 34
 ** module chunks = 0
 **/